import axios from "../axios";

const deleteBankAccount = async function (accessToken, uuid) {
    try {
        const response = await axios.post('/bank-account/deleteBankAccount', {}, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default deleteBankAccount;
